var _defs, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1"
  }, "\n\t\t.Locaiton-st0 {\n\t\t\tfill: currentColor;\n\t\t}\n\t")), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    style: {
      fill: "#cc0028",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "Locaiton-st0",
    d: "M3,9.3L3,9.3C3,9.4,3.1,9.4,3.1,9.5l4.3,6.2C7.6,15.9,7.8,16,8,16c0.2,0,0.4-0.1,0.6-0.3l4.3-6.2   c0-0.1,0.1-0.1,0.1-0.2l0,0c0.8-1.2,1.1-2.7,0.9-4.1c-0.2-1.4-0.9-2.7-2-3.7C10.8,0.5,9.4,0,8,0S5.2,0.5,4.1,1.5   C3,2.4,2.3,3.7,2.1,5.2S2.2,8,3,9.3L3,9.3z M8,3.5c0.7,0,1.3,0.3,1.8,0.7c0.5,0.5,0.7,1.1,0.7,1.8s-0.3,1.3-0.7,1.8   C9.3,8.2,8.7,8.5,8,8.5S6.7,8.2,6.2,7.8C5.8,7.3,5.5,6.7,5.5,6s0.3-1.3,0.7-1.8C6.7,3.8,7.3,3.5,8,3.5L8,3.5z",
    id: "path1",
    style: {
      fill: "#cc0028",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedLocation);
export default __webpack_public_path__ + "static/media/SelectedLocation.651b3ea8fb5f30b95a1b23db5a3ab99f.svg";
export { ForwardRef as ReactComponent };